import { render, staticRenderFns } from "./file.vue?vue&type=template&id=230c8cec&scoped=true"
import script from "./file.js?vue&type=script&lang=js&external"
export * from "./file.js?vue&type=script&lang=js&external"
import style0 from "./file.scss?vue&type=style&index=0&id=230c8cec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c8cec",
  null
  
)

export default component.exports